import {
  Checkbox,
  CommandItem,
  itemVariants,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { CHANNELS_AND_CATEGORIES } from '../../../constants/ComponentsConstants.jsx';
import { snakeCaseToCamelCase } from '../../../utils/snakeCaseToCamelCase.js';
import { OptionItem } from './Filters.types.js';

type FilterOptionsType = {
  checked: boolean;
  onClick: (item: string, isChecked: boolean) => void;
  item: OptionItem;
  level: 0 | 1 | 2 | 3 | 4 | undefined;
};
const FilterOption = ({
  checked,
  onClick,
  item,
  level = 0,
}: FilterOptionsType) => {
  const filterItem = snakeCaseToCamelCase(item.name);
  const categoryProps = CHANNELS_AND_CATEGORIES[filterItem];

  const handleChange = () => {
    onClick(item.name, checked);
  };

  return (
    <CommandItem
      onSelect={handleChange}
      className={cn(
        itemVariants({
          selectionListItem: checked ? 'selected' : 'default',
        }),
        'cursor-pointer',
        'flex',
        'justify-start',
        'gap-2',
        {
          'pl-6': level === 1,
        },
      )}
    >
      <>
        <Checkbox checked={checked} />
        <p className={typographyVariants({ variant: 'bodyShort01' })}>
          {item.label}
        </p>
      </>
      <span className="ml-auto">{categoryProps?.chipProps?.iconComponent}</span>
    </CommandItem>
  );
};

export default FilterOption;
